/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-03 16:13:42
 * @LastEditors: K
 * @LastEditTime: 2022-09-08 14:34:23
 */

import { createAsyncThunk } from '@reduxjs/toolkit'
import { sendAsync } from '../../app/applicationSlice'
import { RootThunkApi } from '../../app/store'
import {
  getTableListFn,
  getDataListFn,
  getAnalysisRecordListFnParams,
  getAnalysisRecordListFn,
  getAllDataFn,
  getAllDataFnParams,
  getActiveInstitutionsFn,
  getActiveInstitutionsFnParams,
  getOverviewListFnParams,
  getOverviewListFn,
  getTendencyChartFn,
  getTendencyChartFnParams,
  getUserAllDataFn,
  getUserAllDataFnParams,
  getUserDoctorPieFnParams,
  getUserDoctorPieFn,
  getOutpatienDataFnParams,
  getOutpatienDataFn,
  getOutpatienDataPieFn,
  getAddServicesDataFn,
  getUseDetailFn,
  getUseDetailFnParams,
  getUseDetailFiveFn,
  getUseDetailFiveFnParams,
  getRegulatoryDataFn,
  getRegulatoryDataFnParams,
  getAllNationalFn,
  getUseDetailExportFn,
} from '../../services/monitoring'

//  获取表格列表
export const getTableList = createAsyncThunk<any, void, RootThunkApi>(
  'stand/getTableList',
  async (_, api) => {
    return sendAsync(getTableListFn(), api)
  }
)
//  获取数据看板
export const getDataList = createAsyncThunk<any, void, RootThunkApi>(
  'stand/getDataList',
  async (_, api) => {
    return sendAsync(getDataListFn(), api)
  }
)
//  获取分析记录
export const getAnalysisRecordList = createAsyncThunk<
  any,
  getAnalysisRecordListFnParams,
  RootThunkApi
>('stand/getDataList', async (params, api) => {
  return sendAsync(getAnalysisRecordListFn(params), api)
})

// 获取折线图数据
export const getTendencyChart = createAsyncThunk<
  any,
  getTendencyChartFnParams,
  RootThunkApi
>('stand/getTendencyChart', async (params, api) => {
  return sendAsync(getTendencyChartFn(params), api)
})

// 机构数据-各省机构总览
export const getOverviewList = createAsyncThunk<
  any,
  getOverviewListFnParams,
  RootThunkApi
>('stand/getOverviewList', async (params, api) => {
  return sendAsync(getOverviewListFn(params), api)
})
// 机构数据-获取数据看板数据 全部 、 好医点、 聚网
export const getAllData = createAsyncThunk<
  any,
  getAllDataFnParams,
  RootThunkApi
>('stand/getAllData', async (params, api) => {
  return sendAsync(getAllDataFn(params), api)
})
// 机构数据-获取机构获取明细
export const getActiveInstitutions = createAsyncThunk<
  any,
  getActiveInstitutionsFnParams,
  RootThunkApi
>('stand/getActiveInstitutions', async (params, api) => {
  return sendAsync(getActiveInstitutionsFn(params), api)
})
// 用户数据-获取数据看板数据 全部 、 好医点、 聚网
export const getUserAllData = createAsyncThunk<
  any,
  getUserAllDataFnParams,
  RootThunkApi
>('stand/getUserAllData', async (params, api) => {
  return sendAsync(getUserAllDataFn(params), api)
})
// 用户数据-机构医生、医生性别、医生年龄饼状图
export const getUserDoctorPie = createAsyncThunk<
  any,
  getUserDoctorPieFnParams,
  RootThunkApi
>('stand/getUserDoctorPie', async (params, api) => {
  return sendAsync(getUserDoctorPieFn(params), api)
})

// 门诊数据-数据看板
export const getOutpatienData = createAsyncThunk<
  any,
  getOutpatienDataFnParams,
  RootThunkApi
>('stand/getOutpatienData', async (params, api) => {
  return sendAsync(getOutpatienDataFn(params), api)
})
// 门诊数据-饼状图
export const getOutpatienDataPie = createAsyncThunk<
  any,
  getOutpatienDataFnParams,
  RootThunkApi
>('stand/getOutpatienDataPie', async (params, api) => {
  return sendAsync(getOutpatienDataPieFn(params), api)
})
// 增值服务-数据看板
export const getAddServicesData = createAsyncThunk<any, void, RootThunkApi>(
  'stand/getAddServicesData',
  async (_, api) => {
    return sendAsync(getAddServicesDataFn(), api)
  }
)
// 使用详情-列表
export const getUseDetail = createAsyncThunk<
  any,
  getUseDetailFnParams,
  RootThunkApi
>('stand/getUseDetail', async (params, api) => {
  return sendAsync(getUseDetailFn(params), api)
})
// 使用详情-列表-前五疾病
export const getUseDetailFive = createAsyncThunk<
  any,
  getUseDetailFiveFnParams,
  RootThunkApi
>('stand/getUseDetailFive', async (params, api) => {
  return sendAsync(getUseDetailFiveFn(params), api)
})
// 使用详情-列表-导出
export const getUseDetailExport = createAsyncThunk<
  any,
  getUseDetailFnParams,
  RootThunkApi
>('stand/getUseDetailExport', async (params, api) => {
  return sendAsync(getUseDetailExportFn(params), api)
})

// 监管数据-浙江省
export const getRegulatoryData = createAsyncThunk<
  any,
  getRegulatoryDataFnParams,
  RootThunkApi
>('stand/getRegulatoryData', async (params, api) => {
  return sendAsync(getRegulatoryDataFn(params), api)
})
// 全国医疗数据
export const getAllNational = createAsyncThunk<
  any,
  void,
  RootThunkApi
>('stand/getAllNational', async (_, api) => {
  return sendAsync(getAllNationalFn(), api)
})
